/**
 * Route Utilities
 * Contains utility functions for route display and processing
 */

/**
 * Get color for driver based on driver number
 * @param {number} driverNumber - The driver's identification number
 * @returns {string} - Hex color code for the driver
 */
export const getDriverColor = (driverNumber) => {
  // Define a set of distinct colors for different drivers
  const driverColors = [
    '#3388ff', // Default blue
    '#ff3333', // Red
    '#33cc33', // Green
    '#ff9900', // Orange
    '#9900cc', // Purple
    '#00cccc', // Teal
    '#ff66cc', // Pink
    '#666666', // Gray
    '#ffcc00', // Yellow
    '#0066ff'  // Royal blue
  ];
  
  // If no driver number or invalid, use default
  if (!driverNumber || driverNumber < 1) {
    return driverColors[0];
  }
  
  // Get color based on driver number (using modulo to cycle through colors)
  const colorIndex = (driverNumber - 1) % driverColors.length;
  return driverColors[colorIndex];
};

/**
 * Decode a Google encoded polyline string into an array of coordinates
 * @param {string} encoded - The encoded polyline string
 * @returns {Array} - Array of [lat, lng] coordinate pairs
 */
export const decodePolyline = (encoded) => {
  if (!encoded) return [];
  
  const poly = [];
  let index = 0, lat = 0, lng = 0;
  
  while (index < encoded.length) {
    let b, shift = 0, result = 0;
    
    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);
    
    const dlat = ((result & 1) ? ~(result >> 1) : (result >> 1));
    lat += dlat;
    
    shift = 0;
    result = 0;
    
    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);
    
    const dlng = ((result & 1) ? ~(result >> 1) : (result >> 1));
    lng += dlng;
    
    const point = [lat * 1e-5, lng * 1e-5];
    poly.push(point);
  }
  
  return poly;
};

/**
 * Default center for Netherlands map
 */
export const DEFAULT_MAP_CENTER = [52.1326, 5.2913];

/**
 * Default zoom level for the map
 */
export const DEFAULT_ZOOM_LEVEL = 7; 